import * as Preact from "preact"

import buildstats from "@frog/source/utility/Buildstats.js"

export default class BuildWidget {
    render() {
        if(buildstats == undefined) {
            return [
                <div class="Build Widget">
                    <div class="Label">Build Size</div>
                    <div class="Value">...</div>
                </div>,
                // <div class="Build Widget">
                //     <div class="Label">Build Time</div>
                //     <div class="Value">...</div>
                // </div>
            ]
        }
        return [
            <div class="Build Widget">
                <div class="Label">Build Size</div>
                <div class="Value">{buildstats.size}</div>
            </div>,
            // <div class="Build Widget">
            //     <div class="Label">Build Time</div>
            //     <div class="Value">{buildstats.time}</div>
            // </div>
        ]
    }
}
